import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  makeGetSlotCategories,
  makeGetSlotName
} from 'store/v1/slot_categories/slot_categories.selectors.js';
import useAutocomplete from 'v1/helpers/hooks/useAutocomplete';
import { filter, isEmpty, orderBy } from 'lodash';
import { SlotCategoryDropdownField } from './SlotCategoryDropdownField.tsx';
import { cn } from '~/v5/platform/dom/cn.js';
import { Button } from 'v5/design-system/Button.js';

const SlotCategoryDropdown = ({
  slot,
  type,
  onSelect,
  filterCategories = undefined,
  buttonClass = '',
  buttonVariant = 'ghost',
  buttonSize = 'sm',
  children
}) => {
  const customTrigger = children;
  const getSlotCategories = useMemo(makeGetSlotCategories, []);
  const slotCategoriesList = useSelector(state =>
    getSlotCategories(state, { type })
  );

  const getSlotName = useSelector(makeGetSlotName);

  const slotCategoriesListMemo = useMemo(
    () => slotCategoriesList,
    [slotCategoriesList]
  );

  const { matches } = useAutocomplete({
    data: slotCategoriesListMemo,
    keyToMatch: 'name'
  });

  let filteredMatches = filterCategories
    ? filter(matches, e => filterCategories.includes(e.id))
    : matches;

  filteredMatches = orderBy(filteredMatches, ['name', 'asc']);

  const label =
    getSlotName(slot, type) ||
    (type === 'EXPENSE' ? 'Select expense' : 'Select role');

  return (
    <div className="tailwind-root">
      <SlotCategoryDropdownField
        popoverClassName="min-w-72"
        options={filteredMatches}
        onSelect={e => {
          onSelect('slot_category_id', Number(e));
        }}
      >
        {customTrigger || (
          <Button
            variant={buttonVariant}
            size={buttonSize}
            className={cn('justify-start', buttonClass)}
          >
            {label}
          </Button>
        )}
      </SlotCategoryDropdownField>
    </div>
  );
};

SlotCategoryDropdown.propTypes = {
  data: PropTypes.array,
  onSelect: PropTypes.func,
  filterCategories: PropTypes.array,
  type: PropTypes.oneOf(['RESOURCE_SLOT', 'EXPENSE']).isRequired
};

SlotCategoryDropdown.defaultProps = {
  data: [],
  onSelect: () => {}
};

export default SlotCategoryDropdown;
